<template>
  <v-dialog v-model="visible" max-width="445" persistent>
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn class="v-dialog--custom__close mr-2" color="gray-6" flat fab @click.native="close(null)">
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-4 pt-0 pb-5 break-word">
        {{ fullToken }}
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn color="accent" depressed round @click.prevent="close(null)">
          {{ $t(`${namespace}.close`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FullTokenDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    fullToken: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      namespace: 'Components.AllowApiToken.fullTokenDialog'
    }
  },
  methods: {
    close (reload = null) {
      this.$emit('close', reload)
    }
  }
}
</script>
<style lang="scss" scoped>
.break-word {
  overflow-wrap: break-word;
}
</style>
